"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const redux_1 = require("@/redux");
const selectors_1 = __importDefault(require("@/selectors"));
const context_1 = __importDefault(require("../../screens/context"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Header = ({ user, logOut }) => {
    const { navOpen, openNav } = (0, react_1.useContext)(context_1.default);
    return (react_1.default.createElement("header", { className: styles_scss_1.default.header },
        react_1.default.createElement("img", { src: constants_1.Images.logo, alt: "Logo", className: styles_scss_1.default.logo }),
        react_1.default.createElement("div", { className: styles_scss_1.default.buttons }, !user ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.loginButton },
                react_1.default.createElement(components_1.Link, { to: constants_1.Routes.Login },
                    react_1.default.createElement("span", null, constants_1.default.login.signIn))),
            react_1.default.createElement(components_1.Link, { to: constants_1.Routes.SignUp },
                react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.signUpButton },
                    react_1.default.createElement("span", null, constants_1.default.login.signUp))))) : (react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.signUpButton, onClick: () => logOut() }, constants_1.default.login.logOut))),
        user && (react_1.default.createElement("div", { className: styles_scss_1.default.burger },
            react_1.default.createElement("input", { type: 'checkbox', checked: navOpen, id: 'nav-toggle', onChange: openNav }),
            react_1.default.createElement("label", { htmlFor: 'nav-toggle' },
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null))))));
};
exports.Header = Header;
const mapStateToProps = (state) => ({ user: selectors_1.default.user.getUser(state), });
const mapDispatchToProps = { logOut: () => redux_1.ActionCreators.user.logOut.dispatch(), };
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(exports.Header);
